var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
export function updateTags(itemId, itemClass, itemTags) {
    return __awaiter(this, void 0, void 0, function* () {
        const { error } = yield GalaxyApi().PUT("/api/tags", {
            body: {
                item_id: itemId,
                item_class: itemClass,
                item_tags: itemTags,
            },
        });
        if (error) {
            rethrowSimple(error);
        }
    });
}
